module.exports = __webpack_public_path__ + "media/components/src/assets/images/form_1-37c7904028012f6946fd3e9a42888141.jpg";